import { render, staticRenderFns } from "./RegisterSurvey.vue?vue&type=template&id=4854c78b&scoped=true"
import script from "./RegisterSurvey.vue?vue&type=script&lang=js"
export * from "./RegisterSurvey.vue?vue&type=script&lang=js"
import style0 from "./RegisterSurvey.vue?vue&type=style&index=0&id=4854c78b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4854c78b",
  null
  
)

export default component.exports